module.exports = __webpack_public_path__ + "static/media/03-09.4e83029a.png";